import axiosClient from '../axiosClient';
import { CustomerAccountReactivationEndpoints } from '../endpoints/customerAccountReactivation';

export interface IDeactivatedUser {
  user_pkid: number;
  user_fname: string;
  user_lname: string;
  user_phone: string;
  user_email: string;
}

export interface IReactivateUserResponse {
  status: boolean;
  message: string;
}

export const CustomerAccountReactivationService = {
  async searchDeactivatedByPhone(phone: string): Promise<IDeactivatedUser[]> {
    const res = await axiosClient.get<IDeactivatedUser[]>(
      CustomerAccountReactivationEndpoints.SEARCH_DEACTIVATED,
      { params: { phone } },
    );
    return res.data;
  },

  async reactivateUser(id: number): Promise<IReactivateUserResponse> {
    const url = CustomerAccountReactivationEndpoints.REACTIVATE_USER.replace(':id', id.toString());
    const res = await axiosClient.put<IReactivateUserResponse>(url);
    return res.data;
  },
};
